import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchEstadoMatricula'
})
export class SearchEstadoMatriculaPipe implements PipeTransform {

  transform(items: any, valor:any): any {
    if(!items) return []
    if(!valor) return items
    return items.filter(item=> item.estado_matricula_glb_estado_id >= valor);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/filters/search-estado-matricula.pipe.ts